import React, { useState, useEffect } from 'react';
import axios from 'axios'; // For making HTTP requests
import { BookOpenIcon } from '@heroicons/react/24/outline';
import baseUrl from '../../config';
import { useNavigate } from 'react-router-dom';
// Assuming baseUrl is correctly configured in your project
// import baseUrl from '../../config'; 


const MyCoursesProgress = () => {
  const navigate = useNavigate(); // Initialize useNavigate

   // State to store fetched course data
    const [courseData, setCourseData] = useState(null);
    // State for loading indicator
    const [loading, setLoading] = useState(true);
    // State for error messages
    const [error, setError] = useState(null);
  console.log(courseData, "baseUrl in MyCoursesProgress.js");
  useEffect(() => {
   
     const fetchMyCourseData = async () => {
       try {
         // Clear any previous errors and set loading to true
         setError(null);
         setLoading(true);

         const response = await axios.get(baseUrl + 'api/students/new/mycourse', {
           headers: {
             // Retrieve authentication token from local storage
             Authorization: `Bearer ${localStorage.getItem('token')}`
           }
         });
         console.log(response, "response.data");
         
         setCourseData(response.data);
         setLoading(false); // Set loading to false once data is fetched
       } catch (err) {
         console.error('Error fetching course data:', err);
         // Set a more user-friendly error message based on the error
         if (err.response && err.response.status === 401) {
           setError('Authentication failed. Please log in again.');
         } else {
           setError('Failed to load course data. Please try again later.');
         }
         setLoading(false); // Set loading to false even if there's an error
       }
     };
 
     // Call the fetch function when the component mounts
     fetchMyCourseData();
   }, []); // Empty dependency array means this effect runs only once on mount

   // Handle loading state
   if (loading) {
     return (
       <div className="bg-white rounded-2xl p-6 shadow-xl border-b-4 border-indigo-600 flex items-center justify-center h-48 animate-pulse">
         <p className="text-gray-700 text-lg font-medium">Loading courses...</p>
       </div>
     );
   }

   // Handle error state
   if (error) {
     return (
       <div className="bg-white rounded-2xl p-6 shadow-xl border-b-4 border-red-600 text-red-700 text-center h-48 flex flex-col items-center justify-center">
         <p className="text-lg font-semibold mb-2">Oops!</p>
         <p className="text-md">{error}</p>
         <button 
            onClick={() => window.location.reload()} // Simple refresh to retry
            className="mt-4 bg-red-500 text-white py-2 px-4 rounded-full text-sm font-semibold hover:bg-red-600 transition-colors"
         >
            Retry
         </button>
       </div>
     );
   }

   // Handle case where courseData is null or empty after loading (e.g., no courses enrolled)
   if (!courseData || Object.keys(courseData).length === 0) {
    return (
      <div className="bg-white rounded-2xl p-6 shadow-xl border-b-4 border-indigo-600 flex items-center justify-center h-48">
        <p className="text-gray-700 text-lg font-medium">No courses found. Enroll in some courses to see your progress here!</p>
      </div>
    );
   }
   
   // Destructure courseData after ensuring it's not null
   const { personalityEnrichmentCourse } = courseData;
 const handleExploreItemClick = () => {
    navigate('/course');
  };

  return (
    <div className="font-inter bg-white rounded-2xl p-6 shadow-xl border-b-4 border-indigo-600 transition-all duration-300 hover:shadow-2xl">
      <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-6 flex items-center">
        <BookOpenIcon className="w-9 h-9 mr-3 text-indigo-600 animate-bounce-in-left" />
        My Courses & Progress
      </h2>
      <ul className="space-y-6">
        {/* Conditional rendering for personalityEnrichmentCourse */}
        {personalityEnrichmentCourse ? (
          <li className="group relative flex flex-col bg-gray-50 p-5 rounded-xl shadow-md border border-gray-100 
                       hover:bg-indigo-50 hover:border-indigo-200 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg">
            
            {/* Top section: Emoji/Icon, Name, Instructor, Schedule */}
            <div className="flex items-start mb-4">
              {/* Emoji/Icon Circle */}
              <div className={`w-14 h-14 rounded-full flex items-center justify-center text-3xl font-bold text-white 
                               ${personalityEnrichmentCourse.gradient} mr-4 flex-shrink-0 
                               shadow-md ring-2 ring-indigo-300 ring-offset-2 group-hover:ring-offset-4 group-hover:ring-indigo-400 transition-all duration-300`}>
                {personalityEnrichmentCourse.emoji}
              </div>
              
              {/* Course Details */}
              <div className="flex-grow">
                <p className="font-bold text-xl text-gray-800 mb-1">{personalityEnrichmentCourse.name}</p>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between text-sm text-gray-600">
                  <p className="md:mb-0">Instructor: <span className="font-semibold text-gray-700">{personalityEnrichmentCourse.instructor}</span></p>
                  <span className="md:ml-4 text-xs md:text-sm text-gray-500 md:text-right italic md:mt-0 mt-1">
                    {personalityEnrichmentCourse.schedule}
                  </span>
                </div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden shadow-inner mb-2">
              <div
                className="bg-indigo-600 h-2.5 rounded-full transition-all duration-700 ease-out shadow-md"
                style={{ width: `${personalityEnrichmentCourse.overallProgress}%` }}
              ></div>
            </div>
            <p className="text-xs text-gray-500 mt-1 text-right font-medium">{personalityEnrichmentCourse.overallProgress}% Completed</p>
            
            {/* Go to Course Button */}
            <button className="mt-4 w-full bg-indigo-600 text-white py-2 rounded-full text-md font-semibold 
                                hover:bg-indigo-700 transition-colors duration-200 shadow-md 
                                hover:shadow-lg hover:scale-105 active:scale-95 active:bg-indigo-800
                                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            onClick={() => handleExploreItemClick()} // Call handler on click

                                >
              Go to Course
            </button>
          </li>
        ) : (
          <li className="text-center text-gray-600 py-6 text-lg bg-gray-50 rounded-xl shadow-sm border border-gray-100">
            No personality enrichment course found.
          </li>
        )}
      </ul>
   

      {/* Tailwind CSS Custom Animations (optional, but adds flair) */}
      <style>{`
        @keyframes bounce-in-left {
          0% {
            opacity: 0;
            transform: translateX(-20px);
          }
          60% {
            opacity: 1;
            transform: translateX(10px);
          }
          80% {
            transform: translateX(-5px);
          }
          100% {
            transform: translateX(0);
          }
        }
        .animate-bounce-in-left {
          animation: bounce-in-left 0.8s ease-out;
        }
      `}</style>
    </div>
  );
};

export default MyCoursesProgress;
